import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {IBookingListItem, ItemsArrayType, ListResponse, LogsItem,} from '@/models';

import {AxiosRequestConfig} from 'axios';
import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {message} from 'antd';
import {persist} from 'zustand/middleware';
import {t} from 'i18next';

export interface IBookingStore {
  bookingList: IBookingListItem[];
  bookingLogs: LogsItem[];
  getAllBooking: (params) => void;
  refundLearner: (learnerId: string, source: string) => void;
  getBookingLogs: () => void;
  nbHits: number;
}

export const useBookingStore = create(
  persist<IBookingStore>(
    set => ({
      bookingList: [],
      nbHits: 0,
      bookingLogs: [],
      getAllBooking: async params => {
        handleApiCallInStore(LoadingKeys.BookingList, async () => {
          const {data} = await http.get<ListResponse<IBookingListItem>>(
            API_ENDPOINTS.booking.all,
            {params} as AxiosRequestConfig
          );
          const {items = [], nbHits = 0} = data || {};
          set(() => ({bookingList: items, nbHits}));
        });
      },
      refundLearner: (learnerId, source) => {
        handleApiCallInStore(LoadingKeys.RefundLearner, async () => {
          if (source === 'admin') {
            message.warning(t('youCantRefundLearnerAddedWithAdmin'));
          } else {
            const {data} = await http.put(
              `${API_ENDPOINTS.booking.refund}/${learnerId}/refund`
            );
            const {items = [], nbHits = 0} = data || {};
            set(() => ({bookingList: items, nbHits}));
          }
        });
      },
      getBookingLogs: () => {
        handleApiCallInStore(LoadingKeys.BookingLogs, async () => {
          const {data} = await http.get<ItemsArrayType<LogsItem>>(
            `${API_ENDPOINTS.logs}${API_ENDPOINTS.booking.logs}`
          );
          set(() => ({bookingLogs: data?.items}));
        });
      },
    }),
    {
      name: 'booking-storage',

    }
  )
);
